import { render, staticRenderFns } from "./ItsDispatch.vue?vue&type=template&id=169d9da4&scoped=true&"
import script from "./ItsDispatch.vue?vue&type=script&lang=js&"
export * from "./ItsDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169d9da4",
  null
  
)

export default component.exports